import {
  PropertyTranslator,
  IGenericRequestParametersTranslator,
  IPaginationParametersTranslator,
  INamedEntityParametersTranslator,
  INamedEntityLabels,
  IPermissionedEntityLabels,
} from "./GenericTranslator";
import {
  IModelWithIntId,
  IPermissionedEntity,
  IRelationModel,
  IPaginationParameters,
  IGenericRequestParameters,
  EntityConstants,
  GenericEntityOrderBy,
  INamedEntity,
  INamedEntityParameters,
  IEntityMinimalModel,
  NamedEntityOrderBy,
} from "./GenericTypes";

export const signaturesConstants: EntityConstants<Signature, SignatureFilters> = {
  resource: "signatures",
  frontendIndexRoute: "signatures",
  entitySingular: "signature",
  entityPlural: "signatures",
  icon: "test-tube-diagonal",
};

export interface Signature extends IModelWithIntId, IPermissionedEntity, INamedEntity {
  signedBy: IEntityMinimalModel;
  timestamp: string;
  signatureType: SignatureType;
  comment?: string;
}

export const SignatureTypes = ["Unknown", "Contributor", "Reviewer"] as const;
export type SignatureType = (typeof SignatureTypes)[number];

export const SignatureFieldLabels: PropertyTranslator<Signature> = {
  ...INamedEntityLabels,
  ...IPermissionedEntityLabels,
  id: "Signature ID",
  signedBy: "Signed By",
  timestamp: "Timestamp",
  signatureType: "Type",
  comment: "Comment",
} as const;

export interface SignatureSuggestions extends IEntityMinimalModel {
  signedBy: IEntityMinimalModel;
  timestamp: string;
  signatureType: SignatureType;
  comment?: string;
}

export interface SignatureRelations extends IRelationModel {}

export const SignatureSortingOptionsConsts = [
  ...GenericEntityOrderBy,
  ...NamedEntityOrderBy,
  "TIMESTAMP",
  "ENTITY_TYPE",
  "STATUS",
] as const;
export type SignatureSortingOptions = (typeof SignatureSortingOptionsConsts)[number];

export interface SignatureFilters
  extends IPaginationParameters,
    IGenericRequestParameters<Signature, SignatureSortingOptions>,
    INamedEntityParameters {}

export const SignatureFiltersTranslator: PropertyTranslator<SignatureFilters> = {
  ...IGenericRequestParametersTranslator,
  ...IPaginationParametersTranslator,
  ...INamedEntityParametersTranslator,
} as const;

export const SignatureSearchTermOptions = {
  searchTermIncludeNames: SignatureFiltersTranslator["searchTermIncludeNames"],
  searchTermIncludeIds: SignatureFiltersTranslator["searchTermIncludeIds"],
} as const;
